<template>
    <div class="global-loader">
        <div class="loader">
            <div class="loader-inner">
                <div class="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="loader-text">
                <span>Идет процесс авторизации...</span>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.global-loader {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    z-index: 10000000;
    display: flex;
    justify-content: center;
    align-items: center;
    .loader {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 50px;
        width: 100%;
        height: 100%;
    }
}

/* From Uiverse.io by AqFox */
.spinner {
    width: 44px;
    height: 44px;
    animation: spinner-y0fdc1 2s infinite ease;
    transform-style: preserve-3d;
}

.spinner > div {
    background-color: rgba(228, 26, 75, 0.2); /* Полупрозрачный основной цвет */
    height: 100%;
    position: absolute;
    width: 100%;
    border: 2px solid #e41a4b; /* Основной цвет для рамки */
}

.spinner div:nth-of-type(1) {
    transform: translateZ(-22px) rotateY(180deg);
}

.spinner div:nth-of-type(2) {
    transform: rotateY(-270deg) translateX(50%);
    transform-origin: top right;
}

.spinner div:nth-of-type(3) {
    transform: rotateY(270deg) translateX(-50%);
    transform-origin: center left;
}

.spinner div:nth-of-type(4) {
    transform: rotateX(90deg) translateY(-50%);
    transform-origin: top center;
}

.spinner div:nth-of-type(5) {
    transform: rotateX(-90deg) translateY(50%);
    transform-origin: bottom center;
}

.spinner div:nth-of-type(6) {
    transform: translateZ(22px);
}

@keyframes spinner-y0fdc1 {
    0% {
        transform: rotate(45deg) rotateX(-25deg) rotateY(25deg);
    }

    50% {
        transform: rotate(45deg) rotateX(-385deg) rotateY(25deg);
    }

    100% {
        transform: rotate(45deg) rotateX(-385deg) rotateY(385deg);
    }
}
</style>
